import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
export var SubmissionScore = /*#__PURE__*/function (_ValueObject) {
  _inherits(SubmissionScore, _ValueObject);

  var _super = _createSuper(SubmissionScore);

  function SubmissionScore() {
    _classCallCheck(this, SubmissionScore);

    return _super.apply(this, arguments);
  }

  _createClass(SubmissionScore, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "create",
    value: function create(value) {
      return Result.ok(new SubmissionScore(value));
    }
  }, {
    key: "createWithValidate",
    value: function createWithValidate(value) {
      var resultOrError = this.validate(value);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      return Result.ok(new SubmissionScore(value));
    }
  }, {
    key: "isNegative",
    value: function isNegative(score) {
      return score < this.minScore;
    }
  }, {
    key: "validate",
    value: function validate(props) {
      if (props < this.minScore) {
        return Result.fail('SubmissionScore cannot be negative');
      }

      return Result.ok();
    }
  }]);

  return SubmissionScore;
}(ValueObject);

_defineProperty(SubmissionScore, "minScore", 0.0);

_defineProperty(SubmissionScore, "defaultValue", -1000);

_defineProperty(SubmissionScore, "default", new SubmissionScore(SubmissionScore.defaultValue));